module.exports = __webpack_public_path__ + "static/ImportVariations-d5ea1c38759ffcfc744e616acdbb22d2.png";